// @ts-nocheck
import { ConfigurationType } from "@insite/client-framework/Services/ProductServiceV2";
import { chain, ValidateProduct } from "@insite/client-framework/Store/Components/ProductSelector/Handlers/SetProduct";
import { hasEnoughInventory } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import { isCustomQuoteRequired } from "@store/Framework/Common/Utilities/productUtilities";
import { replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

/**
 * We only allow variant selection if at least one of them is non configurable.
 * The variant selection modal will only allow selection of non-configurable.
 */
replaceInChain(
    chain,
    ValidateProduct,
    async ({ parameter, product, productInfo, getState, dispatch, variantChildren }) => {
        if (!parameter.validateProduct || !product || !productInfo) {
            return;
        }

        /* Store Custom Code - Start */
        if (isCustomQuoteRequired(product)) {
            dispatch({
                type: "Components/ProductSelector/SetErrorType",
                errorType: "productIsQuoteRequired",
            });
        }

        const configurableChildrens =
            variantChildren &&
            variantChildren?.filter(
                child =>
                    child.canConfigure ||
                    (child.configurationType !== ConfigurationType.None &&
                        (child.configurationType !== ConfigurationType.Fixed || parameter.denyFixedConfiguration)),
            );
        const childrensAreAllConfigurable =
            configurableChildrens && configurableChildrens.length >= variantChildren?.length;
        /* Store Custom Code - End */

        const productIsConfigurable =
            product.canConfigure ||
            (product.configurationType !== ConfigurationType.None &&
                (product.configurationType !== ConfigurationType.Fixed || parameter.denyFixedConfiguration));

        if (productIsConfigurable || childrensAreAllConfigurable /* Store Custom Code */) {
            dispatch({
                type: "Components/ProductSelector/SetErrorType",
                errorType: "productIsConfigurable",
            });
        }

        if (product.isVariantParent && !childrensAreAllConfigurable /* Store Custom Code */) {
            dispatch({
                type: "Components/ProductSelector/OpenVariantModal",
                productId: product.id,
            });

            return false;
        }

        if (!parameter.skipInventoryValidation && !hasEnoughInventory(getState(), { product, productInfo })) {
            dispatch({
                type: "Components/ProductSelector/SetErrorType",
                errorType: "productIsUnavailable",
            });
        }

        if (!product.canAddToCart && !productIsConfigurable && !childrensAreAllConfigurable /* Store Custom Code */) {
            dispatch({
                type: "Components/ProductSelector/SetErrorType",
                errorType: "productIsUnavailable",
            });
        }
    },
);
